require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/core-js/es6/parse-float.js
// module id = ../../../../core-js/es6/parse-float.js
// module chunks = 1